import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import csTranslations from './locales/cs.json';
import deTranslations from './locales/de.json';
import enTranslations from './locales/en.json';
import skTranslations from './locales/sk.json';

const translations = {
  en: {
    translation: enTranslations,
  },
  cs: {
    translation: csTranslations,
  },
  de: {
    translation: deTranslations,
  },
  sk: {
    translation: skTranslations,
  },
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: sessionStorage.getItem('lang') || 'cs',
    fallbackLng: 'cs',
    debug: true,
  });

export default i18n;
